// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div id="userLayout" :class="['user-layout', device]">
    <a-button
      v-if="showClear"
      type="default"
      size="small"
      class="button-clear-notification"
      @click="onClearNotification">{{ $t('label.clear.notification') }}</a-button>
      <a-row>
        <a-col :span="12" class="user-layout-left-column" v-if="device !== 'mobile'">
          <a-row>
            <a-col :span="24" class="user-left-cta">
              <h2 class="left-cta-header"> {{  $t('label.onboard.cta01') }} </h2>
              <p class="left-paragraph"> 
                <ul class="cta-list">
                  <li> {{  $t('label.onboard.cta02') }} </li>
                  <li> {{  $t('label.onboard.cta03') }} </li>
                  <li class="cta04"> {{  $t('label.onboard.cta04') }} </li>
                </ul>
              </p>
              <p class="left-paragraph"> 
                <a target="_blank" href="https://linube.com/" class="ant-btn ant-btn-primary ant-btn-lg login-button know-more"> 
                  <strong>{{ $t('label.onboard.learnmore') }}</strong> </a>
              </p>
              </a-col>
          </a-row>
          <div class="login-footer">
            <a class="footer-link" target="_blank" href="https://es.linkedin.com/company/linube"> LinkedIn </a> | 
            <a class="footer-link" target="_blank" href="https://x.com/LinubeHosting"> X (Twitter) </a> | 
            <a class="footer-link" target="_blank" href="https://linube.com"> {{ $t('label.onboard.cta05') }} </a>
          </div>
        </a-col>
 

    <a-col :span="12" :class="getRightColumnClass()">
      <a-row>
        <a-col :span="24">
          <div class="login-logo">
            <img src="/assets/login-logo.png">
        </div>
        </a-col>
        <a-col :span="24">
        <route-view></route-view>
        </a-col>
      </a-row>

    </a-col>
  </a-row>
  </div>
</template>

<script>
import RouteView from '@/layouts/RouteView'
import { mixinDevice } from '@/utils/mixin.js'
import notification from 'ant-design-vue/es/notification'
import TextScramble from '@/utils/textscramble'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data () {
    return {
      showClear: false,
      title: '',
   }
  },
  watch: {
    '$store.getters.darkMode' (darkMode) {
      if (darkMode) {
        document.body.classList.add('dark-mode')
      } else {
        document.body.classList.remove('dark-mode')
      }
    },
    '$store.getters.countNotify' (countNotify) {
      this.showClear = false
      if (countNotify && countNotify > 0) {
        this.showClear = true
      }
    }
  },
  mounted () {
    document.body.classList.add('userLayout')
    const layoutMode = this.$config.theme['@layout-mode'] || 'light'
    this.$store.dispatch('SetDarkMode', (layoutMode === 'dark'))
    if (layoutMode === 'dark') {
      document.body.classList.add('dark-mode')
    }
    const countNotify = this.$store.getters.countNotify
    this.showClear = false
    if (countNotify && countNotify > 0) {
      this.showClear = true
    }
  },
  beforeUnmount () {
    document.body.classList.remove('userLayout')
    document.body.classList.remove('dark-mode')
  },
  methods: {   
    getRightColumnClass() {
      if (this.device === 'mobile') {
        return 'user-layout-right-column-mobile'
      }
      return 'user-layout-right-column'
    },
    onClearNotification () {
      notification.destroy()
      this.$store.commit('SET_COUNT_NOTIFY', 0)
    },
    runAnimation() {
      const phrases = [
        this.$t('label.onboard.welcome01'),
        this.$t('label.onboard.welcome02'),
        this.$t('label.onboard.cta04')
      ]

      const el = document.querySelector('.cta04')
      const fx = new TextScramble(el)

      let counter = 0
      const next = () => {
        fx.setText(phrases[counter]).then(() => {
          if (counter < phrases.length)
            setTimeout(next, 800)
        })
        counter++
      }

      next()
    }
  },
  mounted() {
    this.runAnimation()
  }
}
</script>

<style lang="less" scoped>
.user-layout { 
  background: url(/img/linubebg.png) no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.login-logo {
  text-align: center;
}
.login-logo img {
  max-width: 250px;
  margin-bottom: 35px;
}
.left-cta-header {
  font-size: 2rem;
  font-weight: 800;
  text-align: left;
  color: #eee;
}
.cta-list {
  font-size: 1.25rem;
}

.user-left-logo {
  max-width: 150px !important;
}

.user-layout-logo {
  max-width: 150px !important;
  text-align:center;
}

.user-left-cta {

  padding: 100px;
  color: #eee;
}

.left-cta-sub {
  color: #eee;

}

.know-more {
  background-color: #D9964C;
  border-color: #D9964C;
}

.user-layout-left-column {
  text-align: left;
  height: 100vh;
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-layout-right-column {
  height: 100vh;
  display: flex;
  max-width: 40%;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.35) 20%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0.35) 80%, rgba(255, 255, 255, 0.15) 100%);
}


.user-layout-right-column-mobile {
  padding-top: 10vh;
  text-align: center;
  margin-left: 20%;
  margin-right: 20%;
}

.mobile-logo {
  text-align: center !important;
  padding-bottom: 20px;
  z-index: 0;
}

.left-paragraph {
  font-size: 1.15rem;
}

.mobile-logo img {
  max-width: 250px;

}
.login-footer {
  color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: left;
  margin-left: 40px;
  margin-bottom: 40px;
}

.footer-link {
  color: #fff;
}



</style>
